import { createContext, useContext } from "react";

import { PaymentsHistoryState } from "features/PaymentsHistory/types";

export const PaymentsHistoryContext = createContext<PaymentsHistoryState | null>(null);

export const usePaymentsHistoryContext = (): PaymentsHistoryState => {
    const state = useContext(PaymentsHistoryContext);

    if (!state) {
        throw new Error("usePaymentsHistoryContext должен использоваться внутри PaymentsHistory");
    }

    return state;
};
